module.exports = __webpack_public_path__ + "static/media/12-7.c0afdfb6.mp3";